/*
 *   Copyright (c) 2021 Propally.Inc
 *   All rights reserved.
 */

import { selector } from "recoil";

import { PROPERTY_TYPE_VALUES } from "../api/mappings/property";

import { PropertyIds, PropertyHoldersState, PropertyHolder, SelectedPropertyId, SelectedPropertyIds } from "./atoms";

export const Properties = selector({
  key: "properties",
  get: ({ get }) => {
    const ids = get(PropertyIds);
    return ids.map((id) => {
      return get(PropertyHoldersState(id));
    });
  },
});

export const OwnedProperties = selector({
  key: "owned_properties",
  get: ({ get }) => {
    // プロパティが undefined でないものだけをフィルタリング
    const properties = get(Properties).filter(property => property !== undefined);

    return properties.filter((property) => {
      return property.property.property_type === PROPERTY_TYPE_VALUES.owned || property.property.property_type === PROPERTY_TYPE_VALUES.owned_sample;
    });
  },
});

export const ConsiderationProperties = selector({
  key: "consideration_properties",
  get: ({ get }) => {
    const properties = get(Properties);

    return properties.filter((property) => {
      return property.property.property_type === PROPERTY_TYPE_VALUES.consideration;
    });
  },
});

export const ProposalProperties = selector({
  key: "proposal_properties",
  get: ({ get }) => {
    const properties = get(Properties);

    return properties.filter((property) => {
      return property.property.property_type === PROPERTY_TYPE_VALUES.proposal;
    });
  },
});

export const SelectedProperty = selector({
  key: "selected_property",
  get: ({ get }) => {
    const selected_property_id = get(SelectedPropertyId);
    const properties = get(Properties);

    return properties.find((property) => {
      return property.id === selected_property_id;
    });
  },
});

export const SelectedProperties = selector({
  key: "selected_properties",
  get: ({ get }): Array<PropertyHolder> => {
    const selected_property_ids = get(SelectedPropertyIds);
    const properties = get(Properties);
    return selected_property_ids.map((e) => {
      return properties.find((property) => {
        return property.id === e;
      });
    });
  },
  set: ({ set }, new_properties: Array<PropertyHolder>) => {
    new_properties.forEach((property) => {
      set(PropertyHoldersState(property.id), property);
    });
  },
});
